import { CallDetailsFragment } from "@/graphql/generated/graphql";

export function mapToSummary(
  transcription: CallDetailsFragment["transcription"] | null
): string | undefined {
  return transcription?.__typename === "CallTranscription"
    ? transcription.insights?.summary?.content?.summary
    : undefined;
}
